import User from "@views/user/User";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "个人中心",
      keepAlive: false,
      footer: true,
      auth: true
    },
    component: User
  },
    {
    path: "/user/bind_phone_account",
    name: "BindPhoneAccount",
    meta: {
      title: "绑定手机账号",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindPhoneAccount.vue")
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "实名认证",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindingPhone.vue")
  },
  {
    path: "/user/auth_statement",
    name: "AuthStatement",
    meta: {
      title: "授权声明",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/AuthStatement.vue")
  },
   {
    path: "/user/auth_status",
    name: "AuthStatus",
    meta: {
      title: "实名认证状态",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/AuthStatus.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收货地址",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddAddress.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "我的账户",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserAccount.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "Poster",
    meta: {
      title: "分销海报",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/user/promotion/Poster.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "签到",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "签到记录",
      keepAlive: true
    },
    component: () => import("@views/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "提现审核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashAudit.vue")
  },
  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "推广人订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "推广人列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的推广",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "账单明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserBill.vue")
  },
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "提现记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashRecord.vue")
  },
  {
    path: "/user/commission",
    name: "CommissionDetails",
    meta: {
      title: "佣金明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionDetails.vue")
  },
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "积分详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Integral.vue")
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserVip.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "个人资料",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/PersonalData.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的优惠券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "领取优惠券",
      keepAlive: true
    },
    component: () => import("@views/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
    name: "UserCash",
    meta: {
      title: "申请提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/customer/list/:productId?",
    name: "CustomerList",
    meta: {
      title: "客服列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge",
    name: "Recharge",
    meta: {
      title: "余额充值",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "推广人排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionRank.vue")
  },
   {
    path: "/user/push_flow",
    name: "PushFlowData",
    meta: {
      title: "流水数据投递",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/PushFlowData.vue")
  },
   {
    path: "/user/housing_auth",
    name: "HousingAuth",
    meta: {
      title: "公积金授权",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/HousingAuth.vue")
  },
  {
    path: "/user/alipay/auth",
    name: "AlipayAuth",
    meta: {
      title: "支付宝授权",
      keepAlive: false,
      backgroundColor: "#f5f5f5",
      auth: true
    },
    component: () => import("@views/user/AlipayAuth.vue")
  },
  {
    path: "/user/alipay/auth/launch",
    name: "AlipayAuthLaunch",
    meta: {
      title: "支付宝授权",
      keepAlive: false,
      backgroundColor: "#f5f5f5",
      auth: false
    },
    component: () => import("@views/user/AlipayAuthLaunch.vue")
  },
  {
    path: "/user/alipay/auth/callback",
    name: "AlipayAuthCallback",
    meta: {
      title: "支付宝授权结果",
      keepAlive: false,
      backgroundColor: "#fff",
      home: false
    },
    component: () => import("@views/user/AlipayAuthCallback.vue")
  },
  {
    path: "/user/credit_auth",
    name: "CreditAuth",
    meta: {
      title: "征信授权",
      keepAlive: false,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/CreditAuth.vue"),
  },
  {
    path: "/user/sign_credit_auth",
    name: "SignCreditAuth",
    meta: {
      title: "征信授权",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/SignCreditAuth.vue"),
  },
  {
    path: "/user/asked_questions",
    name: "AskedQuestions",
    meta: {
      title: "常见问题",
      keepAlive: false,
      backgroundColor: "#f5f5f5"
    },
    component: () => import("@views/user/AskedQuestions.vue")
  },
  {
    path: "/user/feedback",
    name: "Feedback",
    meta: {
      title: "投诉与反馈",
      keepAlive: false,
      backgroundColor: "#f5f5f5"
    },
    component: () => import("@views/user/Feedback.vue")
  },
  {
    path: "/user/complaint_channel",
    name: "ComplaintChannel",
    meta: {
      title: "投诉绿色通道",
      keepAlive: false,
      backgroundColor: "#f5f5f5"
    },
    component: () => import("@views/user/ComplaintChannel.vue")
  },
  {
    path: "/user/opinion_feedback",
    name: "OpinionFeedback",
    meta: {
      title: "意见反馈",
      keepAlive: false,
      backgroundColor: "#f5f5f5",
      auth: true
    },
    component: () => import("@views/user/OpinionFeedback.vue")
  },
  {
    path: "/user/service_terms",
    name: "ServiceTerms",
    meta: {
      title: "服务条款",
      keepAlive: false,
      backgroundColor: "#f5f5f5"
    },
    component: () => import("@views/user/ServiceTerms.vue")
  },
  {
    path: "/user/service_terms/:type",
    name: "ServiceTermsDetail",
    meta: {
      title: "协议详情",
      keepAlive: false,
      backgroundColor: "#fff"
    },
    component: () => import("@views/user/ServiceTermsDetail.vue")
  }
];
